import { render, staticRenderFns } from "./ControlTabLampOverwrite.vue?vue&type=template&id=67d61f98&scoped=true&"
import script from "./ControlTabLampOverwrite.vue?vue&type=script&lang=ts&"
export * from "./ControlTabLampOverwrite.vue?vue&type=script&lang=ts&"
import style0 from "./ControlTabLampOverwrite.vue?vue&type=style&index=0&id=67d61f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d61f98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
